import React from 'react';
import { Input, Select } from 'formik-antd';
import { Divider, Typography } from 'antd';
import FormControl from '~/components/Form/FormControl';
import Box from '~/components/Box';
import Row from '~/components/Row';

export default function AchitectTab({ t, values, errors, touched, countries }) {
  const { Option } = Select;
  const { Text } = Typography;
  return (
    <Box>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="architect.companyName"
          error={(touched.architect?.companyName && errors.architect?.companyName) || errors.architect?.companyName}
          label={t('screens:bids.data.architectCompanyName')}
        >
          <Input name="architect.companyName" autoComplete="off" />
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="architect.representativeName"
          error={
            (touched.architect?.representativeName && errors.architect?.representativeName) ||
            errors.architect?.representativeName
          }
          label={t('screens:bids.data.architectRepresentativeName')}
        >
          <Input name="architect.representativeName" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="architect.representativePhone"
          error={
            (touched.architect?.representativePhone && errors.architect?.representativePhone) ||
            errors.architect?.representativePhone
          }
          label={t('screens:bids.data.architectRepresentativePhone')}
        >
          <Input name="architect.representativePhone" autoComplete="off" maxLength={27} />
        </FormControl>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Text>{t('screens:bids.data.address')}</Text>
      </Divider>
      <Row>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.architect?.address?.addressLineOne && errors.architect?.address?.addressLineOne}
          field="architect.address.addressLineOne"
          label={t('screens:addresses.data.addressLineOne')}
        >
          <Input name="architect.address.addressLineOne" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.architect?.address?.addressLineTwo && errors.architect?.address?.addressLineTwo}
          field="architect.address.addressLineTwo"
          label={t('screens:addresses.data.addressLineTwo')}
        >
          <Input name="architect.address.addressLineTwo" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.architect?.address?.city && errors.architect?.address?.city}
          field="architect.address.city"
          label={t('screens:addresses.data.city')}
        >
          <Input name="architect.address.city" autoComplete="off" maxLength={16} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.architect?.address?.state && errors.architect?.address?.state}
          field="architect.address.state"
          label={t('screens:addresses.data.state')}
        >
          <Input name="architect.address.state" autoComplete="off" maxLength={21} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          field="architect.address.zipCode"
          label={t('screens:addresses.data.zipCode')}
          error={touched.architect?.address?.zipCode && errors.architect?.address?.zipCode}
        >
          <Input name="architect.address.zipCode" autoComplete="off" maxLength={13} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.architect?.address?.country && errors.architect?.address?.country}
          field="architect.address.country"
          label={t('screens:addresses.data.country')}
        >
          <Select name="architect.address.country" placeholder="Select">
            {countries.map(item => {
              return (
                <Option key={item.name} value={item.name}>
                  {item.description}
                </Option>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          cols={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }}
          field="architect.address.note"
          error={(touched.note && errors.note) || errors.note}
          label={t('screens:addresses.data.note')}
        >
          <Input name="architect.address.note" autoComplete="off" maxLength={41} />
        </FormControl>
      </Row>
    </Box>
  );
}
